import { render, staticRenderFns } from "./DiscountPrepositions.vue?vue&type=template&id=22e68824&scoped=true&"
import script from "./DiscountPrepositions.vue?vue&type=script&lang=js&"
export * from "./DiscountPrepositions.vue?vue&type=script&lang=js&"
import style1 from "./DiscountPrepositions.vue?vue&type=style&index=1&id=22e68824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e68824",
  null
  
)

export default component.exports